// Themed typography primitives. Each emits the matching design-system font
// shorthand from the Sky/Sage semantic token tree, so the element participates in
// platform theming rather than carrying its own type scale.
import styled from 'styled-components';

export const Heading1 = styled.h1`
	${p => p.theme.sys.font?.heading?.['1']}
	margin: 0;
`;
export const Heading2 = styled.h2`
	${p => p.theme.sys.font?.heading?.['2']}
	margin: 0;
`;
export const Heading3 = styled.h3`
	${p => p.theme.sys.font?.heading?.['3']}
	margin: 0;
`;
export const Heading4 = styled.h4`
	${p => p.theme.sys.font?.heading?.['4']}
	margin: 0;
`;
export const Subheading1 = styled.p`
	${p => p.theme.sys.font?.subheading?.['1']}
	letter-spacing: 0.15px;
	margin: 0;
`;
export const Subheading2 = styled.p`
	${p => p.theme.sys.font?.subheading?.['2']}
	letter-spacing: 0.15px;
	margin: 0;
`;
export const Label1 = styled.span`
	${p => p.theme.sys.font?.subheading?.['2']}
	margin: 0;
`;
export const Body2 = styled.p`
	${p => p.theme.sys.font?.body?.['2']}
	margin: 0;
`;
export const Body3 = styled.p`
	${p => p.theme.sys.font?.detail?.['1']}
	margin: 0;
`;
// The design system has no "overline" role. The uppercase treatment below is the
// distinguishing feature; the type itself comes from the monospace tags scale,
// matching the eyebrow labels elsewhere in the tree.
export const Overline = styled.span`
	${p => p.theme.sys.font?.tags?.['1']}
	text-transform: uppercase;
	letter-spacing: 0.08em;
	margin: 0;
`;
